import {Link, useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getInstallmentById} from "../functions";
import Loading from "../../../component/Loading/Loading";
import {PickDateTimeWithoutContainer} from "../../../component/PickDate/PickDate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";
import TextInput from "../../../component/TextInput/TextInput";
import {getManagerHeader} from "../../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../../assets/Constants";
import {base64DecodeUnicode, toastSuccess} from "../../../assets/functions";
import InstallmentHistoryForm from "../component/InstallmentHistoryForm/InstallmentHistoryForm";

const UpdateInstallment = () => {
    const navigate = useNavigate()
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);

    const defaultInstallmentHistory = {
        billItemId : "",
        amount : "",
        paymentTimestamp : "",
        payedTimestamp : "",
        description : "",
        privateDescription : "",
    };
    const [installmentHistory, setInstallmentHistory] = useState(defaultInstallmentHistory);

    const handleSubmit = async () => {
        setIsLoading(true);

        const headers = getManagerHeader();
        axios.put(baseCmsApiUrl + 'installmentHistories', installmentHistory, {headers})
            .then((response) => {
                // console.log(response);
                // console.log(response.data);
                toastSuccess(base64DecodeUnicode(response.statusText));
                navigate("/installments");
                return;
            })
            .catch((e) => {
                console.error(e)
                console.log(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {

        (async () => {
            document.title = "اقساط مشتریان";
            const allInstallmentHistory = await getInstallmentById(id);
            // console.log(allInstallmentHistory);
            setInstallmentHistory(allInstallmentHistory);
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>


    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">جزییات قسط {id}#</h1>
            </div>

            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <p>نام
                                خریدار: {installmentHistory.customer.person.firstname + " " + installmentHistory.customer.person.lastname}</p>
                        </div>
                        <div className="col-md-6">
                            <p>شماره تماس خریدار: {installmentHistory.customer.person.activePhonenumber}</p>
                        </div>
                        <div className="col-12">
                            <p>نام محصول: {installmentHistory.singleProduct.persianTitle}</p>
                        </div>
                    </div>


                    <Link className={"ms-auto"} to={`/orders/update/${installmentHistory.billId}`} target={"_blank"}>
                        <FontAwesomeIcon className={"mx-auto"} icon={faEye}/>
                        <span>نمایش فاکتور</span>
                    </Link>
                </div>
            </div>

            <InstallmentHistoryForm instalmentHistory={installmentHistory} onChange={(value)=> {
                console.log(value);
                setInstallmentHistory(value);
            }} />

            <div className="col-12 mt-3">
                <button type={"button"} className={"btn btn-success w-100"} disabled={isLoading}
                        onClick={handleSubmit}>آپدیت فاکتور
                </button>
            </div>



        </div>
    )
}

export default UpdateInstallment;